import SearchableSelect from './SearchableSelect';
import useTenantSearchableSelect from './useTenantSearchableSelect';

type Props = {
  value: string;
  onChange: (tenantName: string) => void;
  label?: string;
  labelId?: string;
  fullWidth?: boolean;
  variant?: 'outlined' | 'standard' | 'filled';
  disableMenuMargin?: boolean;
  hideAllOption?: boolean;
  disabled?: boolean;
};

export const SearchableTenantSelect = ({
  value,
  onChange,
  label = 'Tenant',
  labelId = 'tenant-select-label',
  fullWidth = true,
  variant = 'outlined',
  disableMenuMargin = false,
  hideAllOption = false,
  disabled = false,
}: Props) => {
  const { getOptions, defaultPlaceholder } = useTenantSearchableSelect();

  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      label={label}
      labelId={labelId}
      fullWidth={fullWidth}
      variant={variant}
      placeholder={defaultPlaceholder}
      getOptions={getOptions}
      disableMenuMargin={disableMenuMargin}
      hideAllOption={hideAllOption}
      disabled={disabled}
    />
  );
};

export default SearchableTenantSelect;
